var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18V20C16.5 20.5304 16.2629 21.0391 15.841 21.4142C15.419 21.7893 14.8467 22 14.25 22H5.25C4.65326 22 4.08097 21.7893 3.65901 21.4142C3.23705 21.0391 3 20.5304 3 20V9C3 8.46957 3.23705 7.96086 3.65901 7.58579C4.08097 7.21071 4.65326 7 5.25 7H7.5V18H16.5ZM15.0206 2H9.75C9.15326 2 8.58097 2.21071 8.15901 2.58579C7.73705 2.96086 7.5 3.46957 7.5 4V16C7.5 16.5304 7.73705 17.0391 8.15901 17.4142C8.58097 17.7893 9.15326 18 9.75 18H18.75C19.3467 18 19.919 17.7893 20.341 17.4142C20.7629 17.0391 21 16.5304 21 16V7.242C21 6.97556 20.94 6.71181 20.8237 6.46624C20.7074 6.22068 20.5371 5.99824 20.3228 5.812L16.5934 2.57C16.173 2.20466 15.6085 2.00007 15.0206 2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.52b4307b.svg";
export { ForwardRef as ReactComponent };